(() => {
  const normalise = value => String(value || '').replace(/&amp;/gi, '&').replace(/&quot;/gi, '"').replace(/&#39;|&apos;/gi, "'").replace(/&nbsp;/gi, ' ').normalize('NFKC').toLowerCase().replace(/<[^>]*>/g, '').replace(/[^\p{L}\p{N}]+/gu, '').trim();
  const identity = review => review.uuid || review.id || `${normalise(review.reviewer_name)}:${normalise(review.body || review.body_html)}`;
  const deduplicate = reviews => {
    const seen = new Set();
    return reviews.filter(review => {
      const key = identity(review);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };
  const photoFor = (review, photos) => {
    const boundPhoto = photos.find(photo => photo.review_uuid && photo.review_uuid === review.uuid);
    if (boundPhoto) return boundPhoto;
    const name = normalise(review.reviewer_name || review.reviewer?.name);
    const body = normalise(review.body || review.body_html);
    const rating = Number(review.rating);
    const matches = photos.filter(photo => normalise(photo.reviewer) === name && normalise(photo.message) === body && Number(photo.star_rating) === rating);
    return matches.length === 1 ? matches[0] : null;
  };
  const imageSize = (url, width) => {
    const image = new URL(url, location.origin);
    image.searchParams.set('width', String(width));
    return image.href;
  };
  const enrich = (reviews, photos) => reviews.map(review => {
    const photo = photoFor(review, photos);
    if (!photo || (Array.isArray(review.pictures_urls) && review.pictures_urls.length)) return review;
    return {
      ...review,
      pictures_urls: [{small: imageSize(photo.image_url, 320), compact: imageSize(photo.image_url, 480), big: imageSize(photo.image_url, 1000), huge: imageSize(photo.image_url, 1000), original: photo.image_url}],
      rk_preserved_photo: true
    };
  });
  function renderOriginal(container, reviews) {
    var grid = container.querySelector('#rkMasonryGrid');
    var loadBtn = container.querySelector('#rkMasonryLoad');
    var countNode = container.querySelector('#rkMasonryCount');
    grid.replaceChildren();
  var INITIAL_BATCH = 12;
  var LOAD_BATCH = 8;
  var visibleCount = 0;

  function shuffle(items) {
    var copy = items.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }
    return copy;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }

  function formatDate(value) {
    var parts = String(value || '').split('/');
    if (parts.length !== 3) return escapeHtml(value || '');

    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var month = parseInt(parts[0],10);
    var day = parseInt(parts[1],10);
    var year = parts[2];

    if (!month || !day || !year) return escapeHtml(value || '');
    return months[month - 1] + ' ' + day + ', ' + year;
  }

  function starsHtml(rating) {
    var filled = Math.max(0,Math.min(5,Number(rating) || 0));
    var empty = 5 - filled;
    return '★'.repeat(filled) +
      '<span class="rk-empty">' + '★'.repeat(empty) + '</span>';
  }

  
  function resizedShopifyUrl(url, width) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }
  }

  
  function buildMixedOrder(items) {
    var photos = [];
    var textOnly = [];

    for (var i = 0; i < items.length; i++) {
      if (items[i].image_url) photos.push(items[i]);
      else textOnly.push(items[i]);
    }

    photos = shuffle(photos);
    textOnly = shuffle(textOnly);

    var result = [];
    var p = 0;
    var t = 0;

    while (p < photos.length || t < textOnly.length) {
      if (p < photos.length) result.push(photos[p++]);

      if (t < textOnly.length) result.push(textOnly[t++]);
      if (t < textOnly.length) result.push(textOnly[t++]);
    }

    return result;
  }

  function createCard(review, index) {
    var card = document.createElement('article');
    card.dataset.reviewId = review.uuid;
    card.className =
      'rk-masonry-card' +
      (review.image_url ? ' rk-has-photo' : '');

    var message = review.message || '';
    var longReview = message.length > 360;
    var msgId = 'rkMasonryMsg' + index;

    var imageHtml = '';

    if (review.image_url) {
      var compactPhoto = container.dataset.reviewSelection === 'current_product';
      var src320 = resizedShopifyUrl(review.image_url, compactPhoto ? 144 : 320);
      var src500 = resizedShopifyUrl(review.image_url, compactPhoto ? 288 : 500);

      imageHtml =
        '<div class="rk-masonry-image-wrap">' +
          '<img class="rk-masonry-image" ' +
            'src="' + escapeHtml(src320) + '" ' +
            'srcset="' +
              escapeHtml(src320) + (compactPhoto ? ' 144w, ' : ' 320w, ') +
              escapeHtml(src500) + (compactPhoto ? ' 288w" ' : ' 500w" ') +
            'sizes="' + (compactPhoto ? '(max-width:767px) 80px, 104px' : '(max-width:620px) calc(100vw - 48px), (max-width:900px) calc((100vw - 72px) / 2), 292px') + '" ' +
            'alt="Customer review photo from ' +
              escapeHtml(review.reviewer || 'RomKart customer') + '" ' +
            'loading="lazy" ' +
            'decoding="async" ' +
            'fetchpriority="low">' +
        '</div>';
    }

    card.innerHTML =
      imageHtml +
      '<div class="rk-masonry-body">' +

        '<div class="rk-masonry-person">' +
          '<div>' +
            '<span class="rk-masonry-name">' +
              escapeHtml(review.reviewer || 'Customer') +
            '</span>' +
            '<span class="rk-masonry-date">' +
              escapeHtml(review.date_reviewed) +
            '</span>' +
          '</div>' +
          '<span class="rk-masonry-source">' + escapeHtml(review.source_label) + '</span>' +
        '</div>' +

        '<div class="rk-masonry-card-stars" aria-label="' +
          escapeHtml(review.star_rating) +
          ' out of 5 stars">' +
          starsHtml(review.star_rating) +
        '</div>' +

        '<p class="rk-masonry-message' +
          (longReview ? ' rk-clamped' : '') +
          '" id="' + msgId + '">' +
          escapeHtml(message || 'No written comment was provided.') +
        '</p>' +

        (longReview
          ? '<button type="button" class="rk-masonry-readmore" ' +
              'aria-expanded="false" aria-controls="' + msgId + '">' +
              'Read more' +
            '</button>'
          : '') +

      '</div>';

    var readMore = card.querySelector('.rk-masonry-readmore');

    if (readMore) {
      readMore.addEventListener('click', function() {
        var msg = card.querySelector('.rk-masonry-message');
        var expanded =
          readMore.getAttribute('aria-expanded') === 'true';

        msg.classList.toggle('rk-clamped', expanded);

        readMore.setAttribute(
          'aria-expanded',
          expanded ? 'false' : 'true'
        );

        readMore.textContent =
          expanded ? 'Read more' : 'Show less';
      });
    }

    return card;
  }

  reviews = buildMixedOrder(reviews);

  function updateStatus() {
    var remaining = reviews.length - visibleCount;
    var reviewLabel = reviews.length === 1 ? ' customer review' : ' customer reviews';

    countNode.textContent =
      'Showing ' + visibleCount +
      ' of ' + reviews.length +
      reviewLabel;

    if (remaining <= 0) {
      loadBtn.style.display = 'none';

      countNode.textContent =
        'Showing all ' +
        reviews.length +
        reviewLabel;
    } else {
      loadBtn.style.display = 'inline-flex';

      loadBtn.textContent =
        'Load More Reviews (' +
        remaining +
        ' remaining)';
    }
  }

  function loadBatch(amount) {
    var end =
      Math.min(
        visibleCount + amount,
        reviews.length
      );

    var fragment =
      document.createDocumentFragment();

    for (
      var i = visibleCount;
      i < end;
      i++
    ) {
      fragment.appendChild(
        createCard(reviews[i], i)
      );
    }

    grid.appendChild(fragment);

    visibleCount = end;

    updateStatus();
  }

  loadBtn.addEventListener(
    'click',
    function() {
      loadBatch(LOAD_BATCH);
    }
  );

  loadBtn.hidden = false;
  loadBatch(INITIAL_BATCH);

  }
  const waitForApp = async () => {
    for (let attempt = 0; attempt < 40; attempt += 1) {
      if (window.jdgm?.CDN_BASE_URL) return window.jdgm.CDN_BASE_URL;
      await new Promise(resolve => setTimeout(resolve, 250));
    }
    throw new Error('Review app is unavailable');
  };
  async function mount(container) {
    if (container.dataset.rkMounted === 'true') return;
    container.dataset.rkMounted = 'true';
    try {
      const base = await waitForApp();
      const [manifestResponse, photoResponse] = await Promise.all([fetch(new URL('manifest.json', base)), fetch(container.dataset.photoMapUrl)]);
      if (!manifestResponse.ok || !photoResponse.ok) throw new Error('Review resources are unavailable');
      const [manifest, photos] = await Promise.all([manifestResponse.json(), photoResponse.json()]);
      const key = 'reviews-grid-widget/ReviewsGridWidgetManager.js';
      if (!manifest[key]?.file) throw new Error('Review client is unavailable');
      const module = await import(new URL(manifest[key].file, base).href);
      const client = new module.ReviewsGridWidgetManager(container);
      client.initializeReviewApi();
      client.buildFilters(client.parseDataAttributes());
      const filters = {...client.filters, per_page: 25, display_order: 'most_recent', useCDN: true, ts: container.dataset.sourceUpdatedAt || undefined};
      const first = await client.reviewApi.fetchGridReviews({...filters, page: 1});
      const pageCount = Math.max(1, Number(first.total_pages) || 1);
      const pages = await Promise.all(Array.from({length: pageCount - 1}, (_, index) => client.reviewApi.fetchGridReviews({...filters, page: index + 2})));
      const canonical = deduplicate([first, ...pages].flatMap(page => page.reviews || []));
      const joined = enrich(canonical, photos);
      const reviews = joined.map(review => ({
        uuid: review.uuid || String(review.id),
        reviewer: review.reviewer_name || '',
        date_reviewed: new Date(review.created_at).toLocaleDateString('en-US', {month:'short',day:'numeric',year:'numeric',timeZone:'UTC'}),
        star_rating: review.rating,
        message: review.body || '',
        source_label: review.source === 'shop-app' ? 'Shop review' : 'Customer review',
        image_url: review.pictures_urls?.[0]?.original || review.pictures_urls?.[0]?.huge || review.pictures_urls?.[0]?.compact || ''
      }));
      container.dataset.rkReviewCount = String(reviews.length);
      container.dataset.rkPhotoMatches = String(joined.filter(review => review.rk_preserved_photo).length);
      renderOriginal(container, reviews);
      container.dataset.rkLoaded = 'true';
    } catch (error) {
      container.dataset.rkMounted = 'false';
      container.querySelector('#rkMasonryCount').textContent = container.dataset.unavailableText;
      const retry = container.querySelector('#rkMasonryLoad');
      retry.hidden = false;
      retry.textContent = container.dataset.retryText;
      retry.addEventListener('click', () => mount(container), {once: true});
      console.error('RomKart review sync:', error);
    }
  }
  function start() {
    document.querySelectorAll('[data-rk-review-sync]').forEach(container => {
      if (!('IntersectionObserver' in window)) { mount(container); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); mount(container); }
      }, {rootMargin:'500px'});
      observer.observe(container);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
